export const Legend = ({ text, style={} }) => {
    // we actually style the span element inside the legend element :)
    return (
        <legend style={{display: 'contents'}}><span style={style} className="gruf-legend">{text}</span></legend> 
    )
}